import { useState } from "react";
import {
  ISupportIssueAPIError,
  IUseKelasLiveCMB,
  KelasLiveCMBStages
} from "./kelas-live-cmb.types";
import * as Sentry from "@sentry/react";
import { createSupportIssue } from "services/api/sessions/sessionsService";
import { action, source } from "./kelas-live-cmb.data";
import { IPrimaryUser } from "services/api/api.types";
import { useToast } from "components/atoms/toast/toast-context";
import { useBoolean } from "hooks/use-boolean/use-boolean";
import { useAuth } from "stores/auth/auth-context";

export const useKelasLiveCMB = ({
  primary_user
}: {
  primary_user: IPrimaryUser;
}): IUseKelasLiveCMB => {
  const [contactKakakSiagaStage, setContactKakakSiagaStage] = useState(
    KelasLiveCMBStages.INITIAL_STAGE
  );
  const [showContactKakakSiagaModal, setShowContactKakakSiagaModal] =
    useBoolean();
  const [phoneNumber, setPhoneNumber] = useState(primary_user.phone_number);
  const { addToast } = useToast();
  const { signOutUser } = useAuth();

  const requestCallBack = async (phoneNumber: string) => {
    try {
      setPhoneNumber(phoneNumber);
      await createSupportIssue(
        primary_user.access_token,
        phoneNumber,
        source,
        action
      );
      return true;
    } catch (error) {
      const { status, text } = error as ISupportIssueAPIError;
      if (status === 429) {
        const rateLimitingMessage = text && JSON.parse(text).message;
        addToast({
          heading: rateLimitingMessage,
          variant: "success"
        });
      } else if (status === 401) {
        signOutUser();
      } else {
        addToast({
          heading:
            "Ada yang error. Coba ulang beberapa saat lagi ya, CoFriends",
          variant: "error"
        });
      }
      setShowContactKakakSiagaModal.off();
      setContactKakakSiagaStage(KelasLiveCMBStages.INITIAL_STAGE);
      Sentry.captureException(error);
      return false;
    }
  };

  return {
    contactKakakSiagaStage,
    setContactKakakSiagaStage,
    requestCallBack,
    phoneNumber,
    setPhoneNumber,
    showContactKakakSiagaModal,
    setShowContactKakakSiagaModal
  };
};
